import { render, staticRenderFns } from "./Cporcentaje.vue?vue&type=template&id=ae6d3e5a&"
import script from "./Cporcentaje.vue?vue&type=script&lang=js&"
export * from "./Cporcentaje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports